module.exports = __webpack_public_path__ + "static/img/扬州案例图.0850202.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ds-img/扬州案例图.png
// module id = ymja
// module chunks = 2